<template>
  <div class="user-info">
    <a-popover trigger="hover" placement="bottom" overlayClassName="user-info-dropdown">
      <div class="title">
        <div class="submenu-title-wrapper" :class="{'two-line': auth.branches.length > 1}">
          <div class="name"><b>{{ auth.user.userName }}</b></div>
          <div class="name" v-if="!isCrypto">{{ activeBranchName }}</div>
          <div class="name deposit" v-else>
            <template v-if="!editDepo">
              <a-button size="small" shape="circle" @click="handleEdit" style="margin-top: -6px;">
                <template #icon>
                  <edit-outlined/>
                </template>
              </a-button>
              Депозит:
              <b>{{ getFormattedCurrency(deposit, false, 2) }}</b>
            </template>
            <template v-else>
              <a-button size="small" shape="circle" @click="handleSave">
                <template #icon>
                  <CheckOutlined/>
                </template>
              </a-button>
              <a-input size="small" v-model:value="deposit" placeholder="Депозит"/>
            </template>
          </div>
        </div>
        <a-badge :count="countMessage" title="Количество уведомлений">
          <a-avatar :src="getApiUrl + auth.user.userAvatar">
            <template #icon>
              <user-outlined/>
            </template>
          </a-avatar>
        </a-badge>
      </div>

      <template #content>
        <div>
          <a-menu v-if="auth.user" v-model:selectedKeys="current">
            <template v-if="!isCrypto">
              <a-menu-item key="Profile">
                <router-link :to="{ name: 'Profile' }">Профиль</router-link>
              </a-menu-item>
              <a-menu-item key="Notifications">
                <router-link :to="{ name: 'Notifications' }">
                  <a-badge class="relative-badge" :count="countMessage" title="Количество уведомлений">
                    Уведомления
                  </a-badge>
                </router-link>
              </a-menu-item>
            </template>
            <a-menu-item v-else-if="0" key="Profile">
              <router-link :to="{ name: 'Profile' }">Профиль</router-link>
            </a-menu-item>
            <a-menu-item key="Logout">
              <a @click="handleLogout()">Выход</a>
            </a-menu-item>
          </a-menu>

          <div class="branch" v-if="auth.branches.length > 1 && !isCrypto">
            <h2>Филиал:</h2>
            <div
                class="branch-item" :class="{active: branch.idBranch == auth.currentBranch}"
                v-for="branch in auth.branches" :key="branch.idBranch"
                @click="() => handleChangeBranch(branch.idBranch)"
            >
              {{ branch.branchName }}
            </div>
          </div>
        </div>
      </template>
    </a-popover>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getApiUrl } from "@/utils/getUrls";
import { notification, Button } from 'ant-design-vue';
import api from "@/api/axios";
import webSocket from "@/mixins/webSocket";
import { USER_DATA } from "@/utils/user";
import numberFormat from "@/mixins/numberFormat";
import trade from "@/mixins/trade";

const originalSetItem = localStorage.setItem;

localStorage.setItem = function(key, value) {
  // Вызываем оригинальный метод, чтобы данные записались
  originalSetItem.apply(this, arguments);

  // Создаем и сразу запускаем кастомное событие во window
  const event = new CustomEvent('local-storage-update', {
    detail: { key, value }
  });
  window.dispatchEvent(event);
};

export default {
  name: "UserInfo",
  mixins: [ webSocket, numberFormat, trade ],
  data() {
    return {
      current: [ "" ],
      countMessage: 0,
      getApiUrl,
      deposit: localStorage.getItem(USER_DATA.DEPOSIT) || '0',
      editDepo: false
    };
  },
  watch: {
    $route() {
      this.setCurrent()
    },
    socketData() {
      if (
          this.socketData.type == 'notifications' &&
          this.socketData.data &&
          this.socketData.data.statusNotification == 0
      ) {
        this.countMessage++;
        notification.open({
          placement: 'bottomRight',
          duration: 0,
          description: "Новое уведомление:\r\n" + this.socketData.data.textNotification,
        });
      }
    }
  },
  created() {
    this.setCurrent();
    this.initNotifications();
  },
  mounted() {
    // Вешаем слушатель при монтировании компонента
    window.addEventListener('local-storage-update', this.handleLocalStorageUpdate);
  },
  beforeUnmount() {
    // ОБЯЗАТЕЛЬНО удаляем слушатель при уничтожении компонента
    window.removeEventListener('local-storage-update', this.handleLocalStorageUpdate);
  },
  computed: {
    ...mapGetters({ auth: "auth", socketData: 'WSData' }),
    activeBranchName() {
      if (this.auth && this.auth.branches) {
        const branch = this.auth.branches.find(item => item.idBranch == this.auth.currentBranch);

        return branch.branchName;
      }

      return '';
    },
    isCrypto() {
      return process.env.pack == 'crypto'
    }
  },
  methods: {
    ...mapActions([ "logout", 'startLoading', 'stopLoading' ]),

    handleEdit() {
      this.editDepo = true;
    },

    handleSave() {
      localStorage.setItem(USER_DATA.DEPOSIT, this.deposit);
      this.editDepo = false;
    },

    handleLogout() {
      this.startLoading();
      this.logout()
    },

    setCurrent() {
      const name = this.$route.name;

      if (name) {
        this.current = [ name ];
      }
    },

    handleChangeBranch(id) {
      this.startLoading()
      api.get(`/manage/auth/set-branch?id=${ id }`)
          .then(response => {
            const data = response.data;
            if (data.error) {
              this.$message.error(data.error);
              this.stopLoading()
            } else {
              location.reload();
            }
          });
    },

    initNotifications() {
      this.addWSSubscription({ type: 'notifications' })
      this.getNotifications();
    },

    getNotifications() {
      api.get(`/manage/notifications/get-unread`)
          .then(response => {
            const data = response.data;

            this.countMessage = 0;
            if (data.unread.length > 0) {
              this.countMessage = data.unread.length;
            }

            if (data.unShowed.length > 0) {
              data.unShowed.forEach(item => {
                notification.open({
                  placement: 'bottomRight',
                  duration: 0,
                  description: "Новое уведомление:\r\n" + item.textNotification,
                });
              });
            }
          });
    }
  }
};
</script>

<style lang="less">
.ant-notification-notice {
  background: #595959 !important;
  border-radius: 10px !important;

  .ant-notification-close-x, .ant-notification-notice-description {
    color: white;
  }

  .ant-notification-close-x:hover {
    color: #1890ff;
  }

  .ant-notification-notice-message {
    margin: 0;
  }

  .ant-notification-notice-content {
    padding-right: 20px;
  }
}

.user-info {
  margin-right: 20px;
  display: flex;

  .ant-badge-count {
    min-width: 20px;
    top: 4px !important;
  }

  .ant-avatar {
    margin-left: 5px;
  }

  a {
    color: rgba(0, 0, 0, 0.85);

    &:hover {
      color: #1890ff;
      border-bottom: 2px solid #1890ff
    }
  }

  .title {
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .two-line, .submenu-title-wrapper {
    .name {
      text-align: right;
      line-height: 20px;
      padding-right: 10px;

      .ant-btn {
        position: relative;
        top: 3px;
        margin-top: -3px;
        svg {
          height: 10px;
          width: 10px;
        }
      }

      &.deposit {
        display: flex;
        align-items: center;
        column-gap: 5px;

        b {
          color :#245bff;
        }

        .ant-btn {
          display: none;
        }

        &:hover {
          .ant-btn {
            display: flex;
          }
        }

        input {
          text-align: center;
          position: relative;
          top: 3px;
          margin-top: -3px;
          width: 80px;
        }
      }
    }
  }
}

.user-info-dropdown {
  position: fixed;

  .ant-popover-inner-content {
    padding: 0;

    .ant-menu {
      border-right: none;
      border-radius: 0;
      display: flex;
      flex-flow: column;
      row-gap: 5px;

      .ant-menu-item {
        width: 100%;
        margin: 0;
        height: 30px;
        line-height: 30px;
        padding: 0 10px;

        &:hover {
          span:not(.ant-scroll-number-only) {
            color: #1890ff;
          }
        }

        .ant-badge {
          display: flex;
          height: 100%;
          align-items: center;
        }

        .ant-badge-count {
          display: inline-block;
          transform: none;
          width: 20px !important;
          height: 20px !important;
        }
      }
    }

    .branch {
      padding-top: 10px;

      h2 {
        font-size: 18px;
      }

      .branch-item {
        width: 100%;
        position: relative;
        white-space: nowrap;
        margin-top: 5px;
        height: 30px;
        line-height: 30px;
        padding: 1px 10px;
        border-radius: 8px;

        &:hover, &.active {
          cursor: pointer;
          color: #1890ff;
          padding: 0 9px;
          border: 1px solid #1890ff;
        }
      }
    }
  }
}

.relative-badge {
  .ant-badge-count {
    min-width: 20px;
    position: relative !important;
    margin-left: 5px !important;
    top: 0 !important;
  }
}
</style>